<template>

  <el-container>
    <el-header id="header-box">
      <top-header @toggle-sidebar="toggleSidebar"></top-header>
    </el-header>
    <el-container>
      <!-- 桌面端侧边栏 -->
      <el-aside id="left-menu-list-box" width="200px" class="desktop-sidebar">
        <admin-menu></admin-menu>
      </el-aside>
      <!-- 移动端抽屉式侧边栏 -->
      <el-drawer
        :visible.sync="sidebarVisible"
        direction="ltr"
        size="220px"
        :with-header="false"
        :modal-append-to-body="true"
        class="mobile-sidebar-drawer">
        <admin-menu></admin-menu>
      </el-drawer>
      <el-main>
        <router-view/>
      </el-main>
    </el-container>
  </el-container>

</template>

<script>
  import AdminMenu from './AdminMenu'
  import TopHeader from "./TopHeader";

  export default {
    name: 'AdminIndex',
    components: {TopHeader, AdminMenu},
    data () {
      return {
        sidebarVisible: false
      }
    },
    methods: {
      toggleSidebar() {
        this.sidebarVisible = !this.sidebarVisible
      }
    },
    watch: {
      // 路由变化时关闭移动端侧边栏
      '$route' () {
        this.sidebarVisible = false
      }
    },
    //动态设置侧边栏高度
    mounted() {
      let leftMenuBox = document.getElementById('left-menu-list-box');
      let headerBox = document.getElementById('header-box');
      let dy = window.innerHeight - headerBox.offsetHeight;
      if( leftMenuBox && headerBox){
        leftMenuBox.style.height = dy + 'px';
      }
    }
  }
</script>

<style scoped>

  #left-menu-list-box .el-menu{
    border-right: none;
  }

  .el-header{
    line-height: 46px;
    height: 46px !important;
    border-bottom: 1px solid #e6e6e6;
  }
  .el-aside{
    border-right: solid 1px #e6e6e6;
    line-height: 200px;
  }

  /* 移动端显示汉堡菜单，隐藏桌面端侧边栏 */
  @media screen and (max-width: 768px) {
    .desktop-sidebar {
      display: none !important;
    }
  }

  @media screen and (min-width: 769px) {
    .mobile-sidebar-drawer {
      display: none !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/AdminIndex.vue